module.exports = __webpack_public_path__ + "img/12.d1f2480f.png";